import { takeLatest, put } from 'redux-saga/effects';
import { createAxios, logNative } from '../utils/utils';
import { GET_USER_INFO_80 } from '../config';
import { UPDATE_USER_INFO, GET_USER_INFO } from '../constants/user';

/**
 * 单个排行榜单
 */
function* fetchGetUserInfo({ userInfo }) {
  try {
    let userInfoNew = { ...userInfo };
    if (userInfo && userInfo.st) {
      const axios = yield createAxios('isNeedUser');
      const res = yield axios.get(GET_USER_INFO_80, {
        params: {},
      });
      if (res && res.data && res.data.status === 0 && res.data.data.userHead) {
        userInfoNew.headimgurl = res.data.data.userHead || userInfo.headimgurl;
        userInfoNew.lidNickName = res.data.data.userNickname || userInfo.lidNickName;
      }
    }
    yield put({
      type: UPDATE_USER_INFO,
      userInfo: { ...userInfoNew },
    });
    logNative(`接口获取登录信息, 登录信息变更：`, userInfoNew);
  } catch (err) {
    yield put({
      type: UPDATE_USER_INFO,
      userInfo: { ...userInfo },
    });
  }
}

export function* watchGetUserInfo() {
  yield takeLatest(GET_USER_INFO, fetchGetUserInfo);
}
